import { GridCustomCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import { CpsGridCell } from './CpsGridCell';
import { filePdfIcon, fileExcelIcon, fileWordIcon, fileImageIcon, fileIcon } from '@progress/kendo-svg-icons';
import { SvgIcon } from '@progress/kendo-react-common';
import { EXTENSION_FIELD } from '@cs-cms/types';

const getFileIcon = (extension: string) => {
  const ext = extension?.toLowerCase().replace('.', '');
  const iconStyle = { verticalAlign: 'middle' };

  switch (ext) {
    case 'pdf':
      return <SvgIcon size="medium" style={iconStyle} icon={filePdfIcon} />;
    case 'xlsx':
    case 'xls':
    case 'csv':
      return <SvgIcon size="medium" style={iconStyle} icon={fileExcelIcon} />;
    case 'doc':
    case 'docx':
      return <SvgIcon size="medium" style={iconStyle} icon={fileWordIcon} />;
    case 'jpg':
    case 'jpeg':
    case 'png':
      return <SvgIcon size="medium" style={iconStyle} icon={fileImageIcon} />;
    default:
      return <SvgIcon size="medium" style={iconStyle} icon={fileIcon} />;
  }
};

export const ExtensionCell: React.FC<GridCustomCellProps> = props => {
  const extension = props.dataItem[EXTENSION_FIELD];

  return (
    <CpsGridCell
      dataItem={props.dataItem}
      field={props.field}
      dataIndex={props.dataIndex}
      id={props.id}
      tdProps={props.tdProps}
      columnPosition={props.columnPosition}
      onChange={props.onChange}
      className={props.className}
      colSpan={props.colSpan}
      ariaColumnIndex={props.ariaColumnIndex}
      isSelected={props.isSelected}
      style={props.style}
      rowType={props.rowType}
      level={props.level}
      expanded={props.expanded}
      title={extension || ''}
    >
      {getFileIcon(extension)}
    </CpsGridCell>
  );
};
